export function shouldEnableSemanticQuery(term, open) {
  return Boolean(open && String(term || '').trim())
}

export function partitionSearchResults(items, currentCartId) {
  const seen = new Set()
  const current = []
  const others = []
  for (const item of items || []) {
    if (!item?.id || seen.has(item.id)) continue
    seen.add(item.id)
    if (currentCartId && item.cart_id === currentCartId) current.push(item)
    else others.push(item)
  }
  return { current, others, showGroups: current.length > 0 && others.length > 0 }
}

export function uniqueSavedItems(items) {
  const seen = new Set()
  const unique = []
  for (const item of items || []) {
    if (!item?.id || seen.has(item.id)) continue
    seen.add(item.id)
    unique.push(item)
  }
  return unique
}

export function describeSearchPanelState({
  query,
  isLoading = false,
  isFetching = false,
  isError = false,
  items = [],
  savedItems = [],
} = {}) {
  if (!String(query || '').trim()) return 'idle'
  if (isError) return 'error'
  const total = (items?.length || 0) + (savedItems?.length || 0)
  if (isLoading && total === 0) return 'loading'
  if (total === 0) return isFetching ? 'loading' : 'empty'
  return 'ready'
}

export function searchErrorMessage(error) {
  const status = error?.response?.status
  const detail = error?.response?.data?.detail || error?.message || ''
  const text = String(detail)
  if (status === 503 || /non disponible|embedding|dimension/i.test(text)) {
    return 'La recherche sémantique est indisponible. Ce n’est pas une liste vide.'
  }
  return text || 'La recherche sémantique a échoué.'
}

export function flattenSearchRows({ current = [], others = [], saved = [] } = {}) {
  return [
    ...current.map((item) => ({ item, group: 'current' })),
    ...others.map((item) => ({ item, group: 'others' })),
    ...saved.map((item) => ({ item, group: 'saved' })),
  ]
}
